import React from 'react';
import CardBaseInput from './CardBaseInput';
import utils from '../../helpers/payment-utils';

class CardNumberInput extends CardBaseInput {
  constructor(props) {
    super(props);
    this.cardNumber = undefined;
    this.handleChangeCardNumber = this.handleChangeCardNumber.bind(this);
    this.handleKeyPressCardNumber = this.handleKeyPressCardNumber.bind(this);
  }

  handleChangeCardNumber(props = {}) {
    return e => {
      const formattedCardNumber = e.target.value || '';
      const cardNumber = formattedCardNumber.replace(/\s/g, '');
      const cardNumberField = this.cardNumber;
      let cursorPosition = cardNumberField.selectionStart;

      const cardType = utils.cardTypes.getCardTypeByValue(cardNumber);
      this.setCardType(cardType);
      this.setInputTouched(false);

      const { errorMessages = {}, onChange = () => {}, onCardChange = () => {} } = props;
      onChange && onChange(cardNumber);
      onCardChange && onCardChange(cardType);
      cardNumberField.value = utils.formatter.formatCardNumber(cardNumber);

      // Due to the card number formatting, the selection cursor will fall to the end of
      // the input field. Here, we want to reposition the cursor to the correct place.
      requestAnimationFrame(() => {
        if (document.activeElement !== cardNumberField) return;
        if (cardNumberField.value[cursorPosition - 1] === ' ') {
          cursorPosition = cursorPosition + 1;
        }

        cardNumberField.setSelectionRange(cursorPosition, cursorPosition);
      });

      const error = utils.validator.getCardNumberError(cardNumber, { errorMessages });
      if (error) {
        onChange && onChange('');
        onCardChange && onCardChange(undefined);
      }

      this.setError(error);
    };
  }

  handleKeyPressCardNumber(props = {}) {
    return e => {
      const formattedCardNumber = e.target.value || '';
      const cardNumber = formattedCardNumber.replace(/\s/g, '');

      const { onKeyPress = () => {} } = props;
      onKeyPress && onKeyPress(cardNumber);

      if (e.key !== 'Enter') {
        if (!utils.validator.isNumeric(e)) {
          e.preventDefault();
        }

        if (utils.validator.hasCardNumberReachedMaxLength(cardNumber)) {
          e.preventDefault();
        }
      }
    };
  }

  render() {
    const { onCardChange, ...rest } = this.props;
    const props = {
      'aria-label': 'Card number',
      autoComplete: 'cc-number',
      id: 'cardNumber',
      name: 'cardNumber',
      placeholder: 'Card number',
      type: 'tel',
      ref: ref => (this.cardNumber = ref),
      ...rest,
      onBlur: this.handleBlurInput(this.props),
      onChange: this.handleChangeCardNumber(this.props),
      onKeyPress: this.handleKeyPressCardNumber(this.props),
    };

    const { touched, error } = this.state;

    return (
      <div className="input-area">
        <input {...props} />
        <div className="error-view">{touched && error}</div>
      </div>
    );
  }
}

export default CardNumberInput;
